import { render, staticRenderFns } from "./dictaToolsPopup.vue?vue&type=template&id=59789ea8&scoped=true"
import script from "./dictaToolsPopup.vue?vue&type=script&lang=js"
export * from "./dictaToolsPopup.vue?vue&type=script&lang=js"
import style0 from "./dictaToolsPopup.vue?vue&type=style&index=0&id=59789ea8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59789ea8",
  null
  
)

export default component.exports